<template>
  <CrearAdmision esEditar/>
</template>
  
<script>
  
import CrearAdmision from './CrearAdmision.vue';
  
export default {

  components: {
    CrearAdmision
  },
  
}
</script>